export default __webpack_public_path__ + "static/media/progressbar_rounded_green.283d5bfc.svg";